import { PlatformSyncStatusEnum } from '@/types/generated'

// Special value for showing all platforms
export const FILTER_ALL = 'all' as const
export type PlatformFilterValue = typeof FILTER_ALL | PlatformSyncStatusEnum
